/** @type {import('../types').ProgramConfig} */
export default {
  code: 'IW',
  displayName: 'Incremental Workloads',
  shortName: 'IW',
  color: 'purple',
  statusLabels: {
    approve: 'Approve',
    reject: 'Reject',
    flag_for_manual_review: 'Flag for Manual Review',
  },
  sidebarItems: [],
  listColumns: [],

  feedback: {
    enabled: true,
    validations: [
      { key: 'customer_segment',
        label: '1. Customer Segment (Public Sector / Federal restrictions)',
        keywords: ['customer segment', 'customer_segment'] },
      { key: 'eligible_services',
        label: '2. Eligible Services (allowlist enforcement)',
        keywords: ['eligible services', 'eligible_services'] },
      { key: 'arr_and_cash',
        label: '3. ARR and Cash (funding caps, ARR thresholds)',
        keywords: ['arr and cash', 'validate_arr_and_cash', 'arr cash'] },
      { key: 'activity_name',
        label: '4. Activity Name (sub-program routing keywords)',
        keywords: ['activity name', 'validate_activity_name'] },
      { key: 'sow_content',
        label: '5. SOW Content (statement-of-work parsing)',
        keywords: ['sow content', 'validate_sow_content', 'sow'] },
      { key: 'attached_files',
        label: '6. Attached Files (required documents)',
        keywords: ['attached files', 'attached_files'] },
      { key: 'pricing_calculator',
        label: '7. Pricing Calculator (ARR variance, optimization)',
        keywords: ['pricing calculator', 'validate_pricing_calculator', 'calculator'] },
      { key: 'anomaly_flags',
        label: '8. Anomaly Flags (frequency, dilution, duplicates)',
        keywords: ['anomaly', 'anomaly_flags'] },
      { key: 'blocked_partner',
        label: '9. Blocked Partner (denylist)',
        keywords: ['blocked partner', 'blocked_partner'] },
    ],
    decisionOptions: [
      { value: 'recommend_approval',  label: 'Recommend Approval' },
      { value: 'recommend_rejection', label: 'Recommend Rejection' },
      { value: 'needs_review',        label: 'Needs Review' },
    ],
  },
};
